import { cn } from "@/lib/utils";

const CHIP_CLASS: Record<string, string> = {
  W: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400",
  D: "bg-amber-500/15 text-amber-700 dark:text-amber-400",
  L: "bg-red-500/15 text-red-700 dark:text-red-400",
};

/** Recent results as W/D/L chips, newest first (the order the backend stores them in). */
export function FormChips({ form }: { form?: string[] | null }) {
  if (!form?.length) return <span className="text-muted-foreground">—</span>;
  return (
    <span
      className="inline-flex gap-1"
      title={`Form, newest first: ${form.join(" ")}`}
    >
      {form.map((letter, i) => (
        <span
          key={i}
          className={cn(
            "inline-flex size-5 items-center justify-center rounded text-[11px] font-semibold",
            CHIP_CLASS[letter] ?? "bg-muted text-muted-foreground",
          )}
        >
          {letter}
        </span>
      ))}
    </span>
  );
}
